export const translations = {
    "en": {
        "resume": "Resume",
        "projects": "Projects",
        "contact": "Contact",
        "role": "Full-stack web developer",
        "intro": "I turn complicated tasks into software that is clear, practical, and pleasant to use. Based in Auckland, I build and support enterprise web applications and develop personal projects for the web, desktop, and iOS.",
        "email": "Email me",
        "briefResume": "Brief Resume",
        "background": "My work brings together frontend development, backend maintenance, and SQL reporting. I build internal tools, investigate production issues, and help modernise existing applications. I work with colleagues and clients to understand where a task gets difficult, then develop practical improvements with maintainable code and testing.",
        "download": "Download CV · PDF",
        "personalProjects": "Personal Projects",
        "projectsIntro": "My personal projects turn complicated or tedious tasks into simple, visual experiences that help people learn, organise, and get things done.",
        "github": "View GitHub",
        "moreProjects": "More Projects",
        "letsTalk": "Let's talk.",
        "contactIntro": "Have a workflow to simplify, a product idea, or a development role in mind? Get in touch.",
        "getInTouch": "Get in touch",
        "symbol": "ileaf symbol",
        "resumeFacts": [
            [
                "Experience",
                "Full-stack web development since 2021, with earlier experience in frontend development"
            ],
            [
                "Professional Stack",
                "JavaScript, TypeScript, ColdFusion, SQL, Angular, jQuery, and Ext JS"
            ],
            [
                "Clarity · Craft · Growth",
                "Simplify complicated tasks. Make software feel carefully made. Help people learn, progress, or accomplish something."
            ],
            [
                "Personal Projects",
                "Web, desktop, and iOS apps built with React, Next.js, Electron, and SwiftUI, using Codex to help investigate issues and verify changes"
            ]
        ],
        "language": "Language"
    },
    "es": {
        "resume": "Currículum",
        "projects": "Proyectos",
        "contact": "Contacto",
        "role": "Desarrollador web full-stack",
        "intro": "Transformo tareas complicadas en software claro, práctico y agradable de usar. Desde Auckland, desarrollo y mantengo aplicaciones web empresariales y creo proyectos personales para la web, escritorio e iOS.",
        "email": "Escríbeme",
        "briefResume": "Perfil profesional",
        "background": "Mi trabajo combina desarrollo frontend, mantenimiento backend e informes SQL. Creo herramientas internas, investigo problemas en producción y ayudo a modernizar aplicaciones existentes. Trabajo con colegas y clientes para entender qué dificulta una tarea y desarrollar mejoras prácticas con código mantenible y pruebas.",
        "download": "Descargar CV · PDF (en inglés)",
        "personalProjects": "Proyectos personales",
        "projectsIntro": "Mis proyectos personales transforman tareas complicadas o tediosas en experiencias sencillas y visuales que ayudan a aprender, organizarse y hacer las cosas.",
        "github": "Ver GitHub",
        "moreProjects": "Más proyectos",
        "letsTalk": "Hablemos.",
        "contactIntro": "¿Tienes un proceso que simplificar, una idea de producto o una oportunidad de desarrollo? Escríbeme.",
        "getInTouch": "Contactar",
        "symbol": "Símbolo de ileaf",
        "resumeFacts": [
            [
                "Experiencia",
                "Desarrollo web full-stack desde 2021, con experiencia previa en desarrollo frontend"
            ],
            [
                "Tecnologías profesionales",
                "JavaScript, TypeScript, ColdFusion, SQL, Angular, jQuery y Ext JS"
            ],
            [
                "Claridad · Calidad · Crecimiento",
                "Simplificar tareas complicadas. Crear software con atención al detalle. Ayudar a las personas a aprender, avanzar o lograr sus objetivos."
            ],
            [
                "Proyectos personales",
                "Aplicaciones web, de escritorio e iOS creadas con React, Next.js, Electron y SwiftUI, usando Codex para investigar problemas y verificar cambios"
            ]
        ],
        "language": "Idioma",
        "projectSummaries": {
            "Tendril": "Reúne personas, responsabilidades y lugares en un calendario visual para facilitar la gestión de horarios recurrentes. Incluye detección de conflictos en asignaciones, filtros de calendario, almacenamiento local y exportación de horarios.",
            "Mustard": "Convierte el aprendizaje del orden de los libros de la Biblia en una práctica interactiva. Las actividades de arrastrar y soltar o tocar para intercambiar ofrecen corrección inmediata, puntuación y progreso guardado localmente.",
            "Bloomday": "Reúne los cumpleaños en una aplicación nativa de iOS, con integración de Contactos y edición de cumpleaños. Creada con Swift y SwiftUI, con datos guardados localmente.",
            "Laurel": "Facilita la planificación visual de atuendos al reunir fotos de prendas, conjuntos guardados y generación de atuendos en el dispositivo en una aplicación iOS. Creada con Swift y SwiftUI, con un guardarropa almacenado localmente."
        },
        "tags": {
            "Scheduling": "Planificación",
            "Calendar": "Calendario",
            "Community": "Comunidad",
            "Bible Learning": "Aprendizaje bíblico",
            "Spanish": "Español",
            "Gamified Learning": "Aprendizaje gamificado",
            "Birthday Planner": "Agenda de cumpleaños",
            "Wardrobe": "Guardarropa"
        }
    }
};

export function getBrowserLanguage() {
    const languages = navigator.languages?.length ? navigator.languages : [navigator.language];
    return languages.map((language) => language?.toLowerCase().split("-")[0])
        .find((language) => Object.keys(translations).includes(language)) || "en";
}
